import { Modal } from 'bootstrap';

document.addEventListener('DOMContentLoaded', function (event) {
    class Details {
        constructor() {

            this.DOM = {};
            this.DOM.details = document.querySelector('.details');
            this.init();

        }
        downloadIssue (ev) {
            if (this.DOM.download.dataset.action === 'download') {
                ev.preventDefault();
                const issueId = this.DOM.download.dataset.issue;
                if (issueId) {
                    let downloadBtn = this.DOM.download;
                    downloadBtn.textContent = "Downloading...";
                    var xhr = new XMLHttpRequest();
                    xhr.open('POST', aw.ajaxurl);
                    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                    xhr.onload = function () {
                        if (xhr.status === 200) {
                            var response = xhr.responseText;
                            var newWindow = null;
                            try {
                                newWindow = window.open(response, '_blank');
                                if (newWindow) {
                                    // Pop-up was allowed, do further processing if needed
                                } else {
                                    // Pop-up was blocked
                                    var popup = document.createElement('div');
                                    popup.id = "modalDialogblocked";
                                    popup.innerHTML = '<div id="popupblocked" class="modal fade popupblocked" role="dialog"><div class="modal-dialog modal-nl-preview"><div class="modal-content"><div class="modal-header"><button type="button" class="close closeModal" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button></div><div class="modal-body"><p>Your browser\'s settings prevent pop-up windows from downloading files.</p><p>Please <a class="manualDownloadPDF" href="' + response + '" target="_blank">Click Here</a> to download PDF.</div></div></div></div>';
                                    document.body.appendChild(popup);
                                    var popupBlockedModal = new Modal(document.getElementById('popupblocked'));
                                    popupBlockedModal.show();
                                    var closeButton = document.getElementsByClassName("closeModal")[ 0 ];
                                    var manualDownloadLink = document.getElementsByClassName("manualDownloadPDF")[ 0 ];
                                    closeButton.addEventListener("click", function () {
                                        popupBlockedModal.hide();
                                        document.body.removeChild(popup);
                                    });
                                    manualDownloadLink.addEventListener("click", function () {
                                        popupBlockedModal.hide();
                                        document.body.removeChild(popup);
                                    });
                                }
                            } catch (error) {
                                // Exception occurred while attempting to open the pop-up
                                console.log('Error:', error);
                            }
                            downloadBtn.textContent = "Download PDF";
                        }
                    };
                    var data = 'action=aw_issue_download_url&issue=' + issueId;
                    xhr.send(data);
                }
                return false;
            }
        }
        init () {
            this.DOM.bgUp = this.DOM.details.querySelector('.details__bg--up');
            this.DOM.bgDown = this.DOM.details.querySelector('.details__bg--down');
            this.DOM.img = this.DOM.details.querySelector('.details__img');
            this.DOM.title = this.DOM.details.querySelector('.details__title');
            this.DOM.description = this.DOM.details.querySelector('.details__description');
            this.DOM.actions = this.DOM.details.querySelector('.details__actions');
            this.DOM.readIssue = this.DOM.details.querySelector('.details__read');
            this.DOM.download = this.DOM.details.querySelector('.details__download');
            this.DOM.close = this.DOM.details.querySelector('.details__close');
            this.initEvents();
        }
        initEvents () {
            this.DOM.close.addEventListener('click', () => this.close());
            if (this.DOM.download) {
                this.DOM.download.addEventListener('click', (ev) => this.downloadIssue(ev));
            }
            this.DOM.close.addEventListener('focusout', function (ev) {
                if (document.querySelector('.details--open')) {
                    document.querySelector('.details__read').focus();
                }
            });
        }
        fill (info) {
            this.DOM.img.src = info.img;
            this.DOM.img.alt = 'Magazine cover image';
            this.DOM.img.title = `"${info.title}" Adweek issue magazine cover image`;

            if (this.DOM.title) {
                this.DOM.title.innerHTML = info.title;
            }

            if (this.DOM.description) {
                this.DOM.description.innerHTML = info.description;
            }

            if (this.DOM.download) {
                if (this.DOM.download.dataset.action === 'subscribe') {
                    this.DOM.download.href = '/magazine-download';
                }

                this.DOM.download.dataset.issue = info.issue;
            }
            this.DOM.readIssue.href = info.viewUrl;
            this.DOM.close.dataset.issue = info.issue;
        }
        getProductDetailsRect () {
            return {
                productBgRect: this.DOM.productBg.getBoundingClientRect(),
                detailsBgRect: this.DOM.bgDown.getBoundingClientRect(),
                productImgRect: this.DOM.productImg.getBoundingClientRect(),
                detailsImgRect: this.DOM.img.getBoundingClientRect()
            };
        }
        open (data) {
            if (this.isAnimating) return false;
            this.isAnimating = true;

            this.DOM.details.setAttribute('aria-hidden', 'false');
            this.DOM.details.classList.add('details--open');

            this.DOM.details.classList.add('show');
            this.DOM.details.style.display = 'block';
            this.DOM.details.removeAttribute('aria-hidden');
            this.DOM.details.setAttribute('aria-modal', 'true');
            this.DOM.details.setAttribute('role', 'dialog');
            document.body.classList.add('modal-open');

            this.DOM.productBg = data.productBg;
            this.DOM.productImg = data.productImg;

            this.DOM.productBg.style.opacity = 0;
            this.DOM.productImg.style.opacity = 0;

            const rect = this.getProductDetailsRect();

            this.DOM.bgDown.style.transform = `translateX( ${rect.productBgRect.left - rect.detailsBgRect.left}px ) translateY( ${rect.productBgRect.top - rect.detailsBgRect.top}px ) scaleX( ${rect.productBgRect.width / rect.detailsBgRect.width} ) scaleY( ${rect.productBgRect.height / rect.detailsBgRect.height} )`;
            this.DOM.bgDown.style.opacity = 1;

            this.DOM.img.style.transform = `translateX( ${rect.productImgRect.left - rect.detailsImgRect.left}px ) translateY( ${rect.productImgRect.top - rect.detailsImgRect.top}px ) scaleX( ${rect.productImgRect.width / rect.detailsImgRect.width} ) scaleY( ${rect.productImgRect.height / rect.detailsImgRect.height} )`;
            this.DOM.img.style.opacity = 1;

            anime({
                targets: [ this.DOM.bgDown, this.DOM.img ],
                duration: (target, index) => index ? 400 : 250,
                easing: (target, index) => index ? 'easeInOutBack' : 'easeOutSine',
                elasticity: 0,
                translateX: 0,
                translateY: 0,
                scaleX: 1,
                scaleY: 1,
                complete: () => this.isAnimating = false
            });

            anime({
                targets: [ this.DOM.title, this.DOM.description, this.DOM.actions ].filter(Boolean),
                duration: 400,
                easing: 'easeOutExpo',
                delay: (target, index) => {
                    return index * 60;
                },
                translateY: (target, index, total) => {
                    return index !== total - 1 ? [ 50, 0 ] : 0;
                },
                scale: (target, index, total) => {
                    return index === total - 1 ? [ 0, 1 ] : 1;
                },
                opacity: 1
            });

            anime({
                targets: this.DOM.bgUp,
                duration: 100,
                easing: 'linear',
                opacity: 1
            });

            anime({
                targets: this.DOM.close,
                duration: 250,
                easing: 'easeOutSine',
                translateY: [ '100%', 0 ],
                opacity: 1
            });

            anime({
                targets: DOM.hamburger,
                duration: 250,
                easing: 'easeOutSine',
                translateY: [ 0, '-100%' ]
            });

            this.DOM.actions.focus();
        }
        close () {
            if (this.isAnimating) return false;
            this.isAnimating = true;

            this.DOM.details.setAttribute('aria-hidden', 'true');
            this.DOM.details.classList.remove('details--open');

            this.DOM.details.classList.remove('show');
            this.DOM.details.style.display = 'none';
            this.DOM.details.setAttribute('aria-hidden', 'true');
            this.DOM.details.removeAttribute('aria-modal');
            this.DOM.details.removeAttribute('role');
            document.body.classList.remove('modal-open');

            anime({
                targets: DOM.hamburger,
                duration: 250,
                easing: 'easeOutSine',
                translateY: 0
            });

            anime({
                targets: this.DOM.close,
                duration: 250,
                easing: 'easeOutSine',
                translateY: '100%',
                opacity: 0
            });

            anime({
                targets: this.DOM.bgUp,
                duration: 100,
                easing: 'linear',
                opacity: 0
            });

            anime({
                targets: [ this.DOM.title, this.DOM.description, this.DOM.actions ].filter(Boolean),
                duration: 20,
                easing: 'linear',
                opacity: 0
            });

            const rect = this.getProductDetailsRect();
            anime({
                targets: [ this.DOM.bgDown, this.DOM.img ],
                duration: 250,
                easing: 'easeOutSine',
                translateX: (target, index) => {
                    return index ? rect.productImgRect.left - rect.detailsImgRect.left : rect.productBgRect.left - rect.detailsBgRect.left;
                },
                translateY: (target, index) => {
                    return index ? rect.productImgRect.top - rect.detailsImgRect.top : rect.productBgRect.top - rect.detailsBgRect.top;
                },
                scaleX: (target, index) => {
                    return index ? rect.productImgRect.width / rect.detailsImgRect.width : rect.productBgRect.width / rect.detailsBgRect.width;
                },
                scaleY: (target, index) => {
                    return index ? rect.productImgRect.height / rect.detailsImgRect.height : rect.productBgRect.height / rect.detailsBgRect.height;
                },
                complete: () => {
                    this.DOM.bgDown.style.opacity = 0;
                    this.DOM.img.style.opacity = 0;
                    this.DOM.bgDown.style.transform = 'none';
                    this.DOM.img.style.transform = 'none';
                    this.DOM.productBg.style.opacity = 1;
                    this.DOM.productImg.style.opacity = 1;
                    this.isAnimating = false;
                }
            });
        }
    };

    class Item {
        constructor(el) {
            this.DOM = {};
            this.DOM.el = el;
            this.DOM.product = this.DOM.el.querySelector('.product');
            this.DOM.productBg = this.DOM.product.querySelector('.product__bg');
            this.DOM.productImgURL = this.DOM.product.querySelector('.product__img').parentNode.querySelector('link').href;
            this.DOM.productImg = this.DOM.product.querySelector('.product__img').parentNode.querySelector('img');

            this.info = {
                // img: this.DOM.productImg.src,
                img: this.DOM.productImgURL,
                title: this.DOM.product.querySelector('.product__title').innerHTML,
                description: this.DOM.product.querySelector('.product__description').innerHTML,
                issue: this.DOM.product.dataset.issue,
                viewUrl: this.DOM.product.dataset.view,
                downloadUrl: this.DOM.product.dataset.download
            };

            this.initEvents();
        }
        initEvents () {
            this.DOM.product.addEventListener('click', () => this.open());
            this.DOM.el.addEventListener('keypress', () => this.open());
        }
        open () {
            DOM.details.fill(this.info);
            DOM.details.open({
                productBg: this.DOM.productBg,
                productImg: this.DOM.productImg
            });
        }
    };

    const magazineDetailsWrapper = document.getElementById('magazine_details_wrapper');
    if (magazineDetailsWrapper) {
        const xhrMagazine = new (XMLHttpRequest || ActiveXObject)('MSXML2.XMLHTTP.3.0');
        xhrMagazine.open('GET', adw.ajaxurl + '?action=get_adweek_magazine_issues', false);
        xhrMagazine.setRequestHeader('Content-type', 'application/x-www-form-urlencoded; charset=UTF-8');
        xhrMagazine.onreadystatechange = function () {
            if (xhrMagazine.status == 200) {
                magazineDetailsWrapper.innerHTML = xhrMagazine.responseText;
            }
        };
        xhrMagazine.send();
    }
    const DOM = {};
    DOM.grid = document.querySelector('.adweek-magazine-grid');

    if (DOM.grid) {
        DOM.content = DOM.grid.parentNode;
        DOM.hamburger = document.querySelector('.dummy-menu');
        DOM.gridItems = Array.from(DOM.grid.querySelectorAll('.grid__item'));
        let items = [];
        DOM.gridItems.forEach(item => items.push(new Item(item)));
        DOM.details = new Details();

        let closeBtn = document.querySelector('.details__close');

        document.addEventListener('keydown', function (ev) {
            if (ev.keyCode === 27) {
                setTimeout(function () {
                    closeBtn.click();
                    document.querySelector(`.product[data-issue="${closeBtn.dataset.issue}"]`).parentNode.focus();
                }, 250);
            }
        });

        closeBtn.addEventListener('keydown', function (ev) {
            if (ev.keyCode === 13) {
                setTimeout(function () {
                    closeBtn.click();
                    document.querySelector(`.product[data-issue="${closeBtn.dataset.issue}"]`).parentNode.focus();
                }, 250);
            }
            return true;
        });
    }
});